import { USER_ID_KEY } from '../constants'

export default () => {
  return localStorage.getItem(USER_ID_KEY);
}